import { Toolbar } from '@kerfjs/ui/toolbar';
import type { SafeHtml } from 'kerfjs';

import { PrimaryAddControl } from '../demand-editor/components/primary-add-control.js';

/** Secondary header for Settings › Sites: the admin's "New Site…" action (HS2-DE4RP1). */
export function SitesHeader(): SafeHtml {
  return <Toolbar label="Site Actions" trailing={<PrimaryAddControl action="site-new" label="New Site…" />} />;
}
